import CreditCard from "@components/CreditCard";
import ConfirmationDialog from "@hudson/ui/components/Dialogs/Confirmation";
import Button from "@hudson/ui/components/FormFields/Button";
import { useFormContext } from "@hudson/ui/components/ReactHookForm";
import useContent from "@lib/use_content";
import { useState } from "react";

export default function CreditCardSection({ onDelete }: { onDelete: (ccId: number) => void }) {
  const { data, loading } = useContent([
    "beConfirmDialogDefaultCancelButton",
    "bePudPersonCcRemoveDialogMessage",
    "bePudPersonCcRemoveDialogSubmitButton",
    "bePudPersonCcRemoveDialogSubmitButton",
    "bePudPersonCcSectionTitle",
    "bePaymentRemoveButton",
  ]);
  const [showConfirmation, setShowConfirmation] = useState<be.TokenizedCreditCard | null>(null);

  const creditCard = useFormContext().watch("creditCard");
  const existingCreditCard = creditCard?.token || creditCard?.numberLast4;

  return (
    <div>
      <div className="mt-10 mb-12 space-y-1">
        <h3 className="mb-6 text-xl font-bold leading-6 text-gray-900">
          {data?.content.bePudPersonCcSectionTitle}
        </h3>

        {existingCreditCard ? (
          <div className="flex items-center">
            <CreditCard fieldPrefix="creditCard." tokenizedCard={creditCard} readonly hideCvv />
            <Button
              className="ml-10"
              type="button"
              onClick={async () => setShowConfirmation(creditCard)}
              asLink
            >
              {data?.content.bePaymentRemoveButton}
            </Button>
          </div>
        ) : (
          <CreditCard fieldPrefix="creditCard." hideCvv notRequired />
        )}
      </div>

      <ConfirmationDialog
        cancelLabel={data?.content.beConfirmDialogDefaultCancelButton}
        confirmLabel={data?.content.bePudPersonCcRemoveDialogSubmitButton}
        message={data?.content.bePudPersonCcRemoveDialogMessage}
        onConfirm={async () => {
          await onDelete(parseInt(showConfirmation?.id || ""));
          setShowConfirmation(null);
        }}
        onHide={() => {
          setShowConfirmation(null);
        }}
        show={!!showConfirmation}
        title={data?.content.bePudPersonCcRemoveDialogSubmitButton}
        zIndexClass="z-50"
      />
    </div>
  );
}
